import { DefaultTheme } from 'styled-components';

const general: DefaultTheme['general'] = {
  borderRadius: '4px',
  paddingBtn: '22px',
  columnWidth: 49, // this is in px
  gutterWidth: 5, // this is in px
  boxShadow: `10px 10px 20px 0`,
  boxShadowHover: `0px 5px 10px 0`,
  boxShadowInput: `0 4px 8px 0`,
  boxShadowInputHover: `0 2px 4px 0`,
  boxShadowPricing: `0 20px 40px 0`,
  boxShadowMenu: `0 0 10px`,
};

export default general;
